import React, { useEffect, useState } from 'react';
import styles from './RangeAnalysisTab.module.css';
import { useRangeAnalysisVehicleData } from './Context';
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';

const SingleChargePerformance = () => {
  const [toggleBy, setToggleBy] = useState("National")

  const { isLoading, error, sendReq: fetchData } = useHttp();
  const { GlobalData, setGlobalData } = useRangeAnalysisVehicleData()

  const [kpiData, setKpiData] = useState({
    "300Plus": null,
    "300To250": null,
    "250To200": null,
    "200To150": null,
    "AvgKmDriven": null,
  })


  const performanceData = [
    { key: "300Plus", range: '300+ Kms', unit: 'Vehicles', color: 'primary' },
    { key: "300To250", range: '300 - 250 Kms', unit: 'Vehicles', color: 'success' },
    { key: "250To200", range: '250 - 200 Kms', unit: 'Vehicles', color: 'warning' },
    { key: "200To150", range: '200 - 150 Kms', unit: 'Vehicles', color: 'danger' },
    { key: "AvgKmDriven", range: 'Avg. Km Driven', unit: '', color: 'info' }
  ];

  useEffect(() => {
    let filterData = toggleBy === "Depo"
      ? {
        ...GlobalData,
        "VIN_NUM": [],
        "CITY": [],
      }
      : {
        ...GlobalData,
        "VIN_NUM": [],
        "CITY": [],
        "DEPO": [],
      }


    fetchData({ url: API_URL_MAIN + `mileage_saarthi_range/single_charge_performance_range`, body: { filterdata: filterData } },
      (data) => {
        setKpiData(prev => ({
          ...prev,
          "300Plus": data?.bucketCounts?.["300+"],
          "300To250": data?.bucketCounts?.["300-250"],
          "250To200": data?.bucketCounts?.["250-200"],
          "200To150": data?.bucketCounts?.["200-150"],
          "AvgKmDriven": data?.Avg_km_Driven,
        }))
      }
    )
  }, [GlobalData, toggleBy])

  return (
    <div className="card mb-4">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h5 className={`card-title ${styles.cardTitle}`}>Single Charge Performance on Basis of Range</h5>
          <div className="btn-group" role="group">
            <button
              type="button"
              className={`btn btn-sm ms_btn  ${styles.performanceToggleBtn} ${toggleBy === 'National' ? "active" : ''}`}
              onClick={() => setToggleBy('National')}
            >
              National
            </button>
            <button
              type="button"
              className={`btn btn-sm ms_btn  ${styles.performanceToggleBtn} ${toggleBy === 'Depo' ? 'active' : ''
                }`}
              onClick={() => setToggleBy('Depo')}
            >
              Depo
            </button>
          </div>
        </div>

        <div className="row g-3">
          {performanceData?.map((item, index) => (
            <div key={index} className="col-md-2 col-sm-6">
              <div className={`card text-center  ${styles.performanceCard}`}>
                <div className="card-body py-3">
                  <h6 className={`card-title ${styles.performanceCardTitle}`}>{item.range}</h6>
                  <p className="card-text small text-muted mb-0">{kpiData?.[item.key] !== null ? kpiData?.[item.key] + " " + item.unit : "--"} </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SingleChargePerformance;